export default __webpack_public_path__ + "images/d968d4b6913c8db774770d3bd430d509.svg";